











import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({
  name: 'OtpInputSingle',
})
export default class extends Vue {
  @Prop()
  value!: string

  @Prop()
  hasFocus!: boolean

  // NOTE: this is a prop because the autofocus attr has bad compatibility with older iOS (tested on iOS 16.4 and 18.5)
  @Prop({ default: false })
  autofocus!: boolean

  @Prop({ default: 'text' })
  inputType!: HTMLInputElement['type']

  @Prop({ default: 'text' })
  inputMode!: HTMLInputElement['inputMode']

  @Prop({ default: false })
  autocapitalize!: boolean

  localValue: string = this.value

  created() {
    document.addEventListener('selectionchange', this.handleSelectionReset)
  }

  destroyed() {
    document.removeEventListener('selectionchange', this.handleSelectionReset)
  }

  mounted() {
    // in some situations, the `autofocus` attribute in the dom isn't respected, so we need to set focus via js
    if (this.autofocus) this.focus()
  }

  focus() {
    const input = this.$refs.input as HTMLInputElement
    input.focus()
  }

  /** Ensure the entire input is selected, so that typing a character will always replace the value. This handler should be attached to the document, not the input element, for compatibility with older browsers. https://caniuse.com/?search=selectionchange */
  handleSelectionReset() {
    const input = this.$refs.input as HTMLInputElement

    if (document.activeElement !== input) return

    if (input.selectionStart !== 0 || input.selectionEnd !== 0) {
      input.selectionStart = 0
      input.selectionEnd = 0
    }
  }

  /** Sanitise input so only valid characters are allowed, and reset input element to a valid value */
  handleInput(event: InputEvent) {
    const input = event.target as HTMLInputElement

    const validPattern = this.inputType === 'number' ? /^[0-9]$/ : /^[a-zA-Z0-9]$/
    const isValidInput = validPattern.test(event.data ?? '')

    if (isValidInput) this.localValue = this.autocapitalize ? event.data!.toUpperCase() : event.data!

    // at this point, the input element might have an invalid value in the DOM state, so force update the input element so that the component (this and the parent's) logic never runs with an invalid value
    input.value = this.localValue

    if (isValidInput) this.emitChange(this.localValue)
  }

  @Watch('value')
  onValueChange() {
    this.localValue = this.value
  }

  @Watch('hasFocus')
  onFocusChange() {
    if (this.hasFocus) this.focus()
  }

  @Emit('on-keydown') handleKeyDown() {}
  @Emit('on-paste') handlePaste() {}
  @Emit('on-focus') handleFocus() {}
  @Emit('on-blur') handleBlur() {}
  @Emit('on-change') emitChange(value: string) {
    return value
  }
}
